"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const claimBannerTranslations_json_1 = __importDefault(require("./claimBannerTranslations/claimBannerTranslations.json"));
require("./claimBanner.scss");
const BaseButton_1 = __importDefault(require("../../../elementKit/baseButton/BaseButton"));
function ClaimBanner(props) {
    props.addTranslation(claimBannerTranslations_json_1.default);
    return (react_1.default.createElement("div", { id: "claim-banner" },
        react_1.default.createElement("span", { className: "claim-info" }, props.translate("claimInfo").toString()),
        react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", loading: false, height: 35, onClickAction: () => props.onClick(), className: "claim-button" },
            react_1.default.createElement("span", null, props.translate("claimButton").toString()))));
}
exports.default = ClaimBanner;
